export default function setBgDarken() {

  /* Elements */
  const videoBodyElm = document.getElementById('js-bgVideo');
  const videoElm = videoBodyElm.querySelector('video');
  const aboutSec = document.querySelector('.js-aboutSec');

  /* observer */
  function viewArea(entries, object) {
    entries.forEach(function (entry, i) {
      if (entry.isIntersecting) {
        videoBodyElm.classList.add('is-darken');
        // videoElm.play();
      } else {
        videoBodyElm.classList.remove('is-darken');
        // videoElm.pause();
      }
    });
  };
  let options = {
    rootMargin: '0px 0px -15% 0px'
  }
  let observer = new IntersectionObserver(viewArea, options);

  /* init */
  observer.observe(aboutSec);

}